var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketsRaised(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_386_90571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8857 4.77026L23.0107 2.89526L21.1357 4.77026L19.2607 2.89526L17.3857 4.77026L15.5107 2.89526L13.6357 4.77026L11.7607 2.89526L9.88574 4.77026L8.01074 2.89526V20.3953H4.26074V24.1453C4.26074 26.2203 5.93574 27.8953 8.01074 27.8953H23.0107C25.0857 27.8953 26.7607 26.2203 26.7607 24.1453V2.89526L24.8857 4.77026ZM19.2607 25.3953H8.01074C7.32324 25.3953 6.76074 24.8328 6.76074 24.1453V22.8953H19.2607V25.3953ZM24.2607 24.1453C24.2607 24.8328 23.6982 25.3953 23.0107 25.3953C22.3232 25.3953 21.7607 24.8328 21.7607 24.1453V20.3953H10.5107V6.64526H24.2607V24.1453Z",
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2607 9.14526H11.7607V11.6453H19.2607V9.14526Z",
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0107 9.14526H20.5107V11.6453H23.0107V9.14526Z",
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2607 12.8953H11.7607V15.3953H19.2607V12.8953Z",
    fill: "#2D3748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0107 12.8953H20.5107V15.3953H23.0107V12.8953Z",
    fill: "#2D3748"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_386_90571"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.510742,
    y: 0.395264,
    width: 30,
    height: 30,
    rx: 6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketsRaised);
export default __webpack_public_path__ + "static/media/TicketsRaised.238aa32a3e7e08dbfe92042c5e655a69.svg";
export { ForwardRef as ReactComponent };